import { useState } from "react";
import pdfCarbon from "../../assets/pdfs/uacns-carbon.pdf";
import pdfAluminium from "../../assets/pdfs/uacns-aluminium.pdf";
import pdfZags from "../../assets/pdfs/zags.pdf";
import pdfSilo from "../../assets/pdfs/silo-trailer.pdf";
import generalCatalog from "../../assets/pdfs/general-catalog-2025.pdf";

const technicalDataSheets = [
  {
    title: "Uacns 82 m³ Carbon Steel Technical Data Sheet",
    file: pdfCarbon,
  },
  {
    title: "Uacns 82 m³ Aluminium Technical Data Sheet",
    file: pdfAluminium,
  },
  {
    title: "Zags 117 m³ Technical Data Sheet",
    file: pdfZags,
  },
  {
    title: "Silo Trailer 60 m³ Technical Data Sheet",
    file: pdfSilo,
  },
];

function DownloadCenter() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    
    <div className="px-20 md:px-12 lg:px-24 py-10 ">
      <h2 className="text-2xl md:text-3xl text-white">Download Center</h2>
      <p className="italic mt-2 text-white">Find all essential documents here.</p>
      <p className="text-white mb-6">
        From product catalogues to technical sheets and user guides—everything in one place.
      </p>

      {/* General Catalog */}
      <div className="border-t border-black py-6 flex justify-between items-center">
        <span className="font-medium text-white text-lg">General Catalog 2025</span>
        <a
          href= {generalCatalog}
          download
          className="text-sm text-white hover:underline flex items-center gap-1"
        >
          DOWNLOAD PDF<span className="text-sm">⬇</span>
        </a>
      </div>

      {/* Technical Data Sheets */}
      <div className="border-t border-black">
        <div
          className="py-4 cursor-pointer flex justify-between items-center text-white"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          <span className="font-medium text-white text-lg">Technical Data Sheets</span>
          <span className="text-xl text-white">{isExpanded ? "▾" : "▸"}</span>
        </div>

        {isExpanded &&
          technicalDataSheets.map((item, i) => (
            <div
              key={i}
              className="border-t border-gray-300 py-4 flex justify-between items-center"
            >
              <span className="text-sm text-white md:text-base">{item.title}</span>
              <a
                href={item.file}
                download
                className="text-sm flex items-centergap-1 text-white"
              >
                DOWNLOAD PDF <span className="text-sm">⬇</span>
              </a>
            </div>
          ))}
      </div>
    </div>
  );
}

export default DownloadCenter;
